import { resolveMediaUrl } from '@/config/app'

export function getUserDisplayName (user) {
  if (!user) return ''
  return user.nomeCompleto || user.usuarioNome || user.nome || `#${user.id || ''}`
}

export function getUserInitials (user) {
  const name = getUserDisplayName(user)
  if (!name) return '?'
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

export function getUserPhotoUrl (user) {
  const raw = user?.fotoPerfil || user?.usuarioFotoPerfil
  if (!raw || !String(raw).trim()) return null
  return resolveMediaUrl(raw)
}
